module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I dedicate this book to my mom, Dolores Hudson, and grandmother, Gladys Herron, for their profound presence and for making me the woman that I am today.")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To Glenn M. Ross for his devout spirit, for his support, and for being an awesome son. To my uncle Meyers B. Herron for believing in me when no one else did. To my sister Charmaine Davenport for encouraging me to stay focused. To my sister Michelle Burnett for being tremendously understanding of my purpose. To my best friends Robyn Smith and Clarice Marshall for cheering me on and listening to me whine during countless nights. To Darlene Ross for loving me as I am and for never disappointing me. To my dearest friend Ruth Garnett for her words of wisdom.")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Last, but not least, to my husband, Henry D. Washington Jr., for his patience and unconditional love.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48141b2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedication.vue
// module id = 66
// module chunks = 0